import React, { useState, useEffect } from "react";
import { LoadingIcon } from '@prosolve/common-components-ui'
import useFetch from '../../../../hooks/useFetch';
import UserCard from "../../../UserCard/UserCard";
import useIsMobileView from "../../../../hooks/useIsMobileView";

export default ({
  eventData = {}
}) => {
  const isMobileView = useIsMobileView();

  const fetch = useFetch();

  const isLoading = false;

  const { accountId } = eventData;

  const [csSpecialistData, setCsSpecialistData] = useState({})

  const {
    name = '',
    email = '',
    phone = '',
    ownerName = '',
    ownerEmail = '',
    ownerPhone = '',
  } = csSpecialistData;

  const fetchCsSpecialistData = async (accountId) => {
    try {
      const response = await fetch(`accounts/account/csspecialist?accountId=${accountId}`, { method: 'GET' })
      const csspecialist = await response.json()
      setCsSpecialistData(csspecialist)
    } catch (e) {
      setCsSpecialistData({})
    }
  }

  useEffect(() => {
    if (accountId) {
      fetchCsSpecialistData(accountId)
    } else {
      setCsSpecialistData({})
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [accountId])

  const TitleAndCardBlock = ({ title, nameStr, emailStr, phoneStr }) => {
    return (
      <div
        style={{
          width: isMobileView ? 'calc(100vw - 50px)' : 'auto',
          padding: '20px',
          display: 'flex',
          flexDirection: 'column'
        }}
      >
        <div style={{
          display: 'flex',
          alignItems: 'center'
        }}>
          <div style={{
            flex: 1,
            color: '#565656',
            fontSize: '24px',
            fontWeight: 'bold',
            marginLeft: '20px'
          }}>
            {title}
          </div>
        </div>
        {
          isLoading ?
            <div style={{
              flex: 1,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              padding: '20px'
            }}>
              <LoadingIcon />
            </div>
            :
            <div style={{
              flex: 1,
              display: 'flex',
              flexDirection: isMobileView ? 'column' : 'row',
              columnGap: '20px',
              rowGap: '20px',
              padding: '20px',
              flexWrap: 'wrap'
            }}>
              {
                Boolean(nameStr) ?
                  <UserCard name={nameStr} email={emailStr} phone={phoneStr} />
                  :
                  <div style={{ marginTop: '5px', marginLeft: '5px' }}>
                    {'None Assigned'}
                  </div>
              }
            </div>
        }
      </div>
    )
  }

  return (
    <>
      <TitleAndCardBlock title='Customer Success Specialist' nameStr={name} emailStr={email} phoneStr={phone} />
      <TitleAndCardBlock title='Account Specialist' nameStr={ownerName} emailStr={ownerEmail} phoneStr={ownerPhone} />
    </>
  )
}